import React, { memo, useCallback, useEffect, useRef, useState } from "react";
import { logEvent } from "@Lib/analytics";
import styles from "./RelatedCar.module.less";
import { host } from "@Services/url";
import CarItem from "@Components/article/feature/CarItem/Index";

interface IProps {
  style?: React.CSSProperties;
  source: string;
  gaId: string;
  scrollNumber: Array<any>;
  dataSource: any;
}

const RelatedCar = (props: IProps) => {
  const { style, source, scrollNumber, dataSource, gaId } = props;

  const [data, setData] = useState<any[]>([]);
  const targetRef = useRef<HTMLDivElement>(null);
  const [left, setLeft] = useState<boolean>(true);
  const [right, setRight] = useState<boolean>(false);

  useEffect(() => {
    if (dataSource && dataSource.length !== 0) {
      setData(dataSource);
    }
  }, [dataSource]);

  const scrollTo = useCallback((scrollValue) => {
    let scrollLeft = targetRef.current!.scrollLeft;
    targetRef.current!.scrollTo(scrollLeft + scrollValue, 0);
  }, []);

  const onScroll = useCallback((e) => {
    const scrollLenght = targetRef.current!.scrollWidth - scrollNumber[0];
    let scrollLeft = e?.currentTarget?.scrollLeft;
    setRight(scrollLeft === scrollLenght);
    setLeft(scrollLeft === 0);
  }, []);

  useEffect(() => {
    targetRef.current!.addEventListener("scroll", onScroll);

    return () => {
      targetRef.current!.removeEventListener("scroll", onScroll);
    };
  }, []);

  return (
    <section className={styles["RelatedCar"]} style={style}>
      {!!data.length && (
        <>
          <p className={styles["title"]}>相關車款</p>
          {!left && data.length > 3 && <i className={styles["left-icon"]} onClick={() => scrollTo(scrollNumber[1])} />}
          {!right && data.length > 3 && (
            <i className={styles["right-icon"]} onClick={() => scrollTo(scrollNumber[2])} />
          )}
        </>
      )}

      <div className={styles["brand-scroll"]} ref={targetRef}>
        {Array.isArray(data) && !!data.length &&
          data.map((item) => (
            <div style={{ marginRight: "24px" }} key={item.kindId}>
              <CarItem
                key={item.kindId}
                source={source}
                gaId={gaId}
                dataObj={{
                  ads: item.ads,
                  kindId: item.kindId,
                  thumb: item.thumb,
                  brandName: item.brandName,
                  kindName: item.kindName,
                  price: `${item.inquiryNum == 0 ? " " : `${item.inquiryNum}人詢價`}`,
                  modelNum: item.price,
                  inquiry: item.isInquiry,
                  brandId: item.brandId,
                  menuCount: item.menuCount,
                  visitsRank: item.visitsRank,
                  maxDiscountPrice: item.discountPriceForInt,
                  picHref: `${
                    item.ads && item.ads.adclick !== ""
                      ? item.ads.adclick
                      : `${host.c}/photoModel-info.html?k=${item.kindId}`
                  }`,
                  btnHref: `${
                    item.ads && item.ads.adclick !== ""
                      ? item.ads.adclick
                      : `${host.c}/ask/price?b=${item.brandId}&k=${item.kindId}&source=${!!item?.discountPriceForInt ? `${source}-領取優惠` : `${source}-一鍵詢價`}`
                  }`,
                }}
              />
            </div>
          ))}
      </div>
    </section>
  );
};
export default memo(RelatedCar);
